import { AdPodFilter, AdPodUpdate, ListResult, SearchableFilter } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'
import type { RequestOptions } from 'common/network/request-options'

import { AdPod, AdPodInit } from 'common/api/v1/types'
import { AdPodsRequestParams, singleSortQueryFromPaginatedRequestParams } from '../nm-types'

export class AdPodsApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async listAdPods(params: AdPodsRequestParams, options?: Pick<RequestOptions, 'signal'>): Promise<ListResult<AdPod>> {
    const filter = {
      searchName: params.filter,
      fromDate: params.fromDate ? new Date(params.fromDate) : undefined,
      toDate: params.toDate ? new Date(params.toDate) : undefined,
      adCreativeId: params.adCreativeId,
      status: params.status,
    } as AdPodFilter

    const query = singleSortQueryFromPaginatedRequestParams<SearchableFilter, string>({
      filter,
      paginatedRequestParams: params,
    })
    return this.edgeClient.listAdPods(query, options)
  }

  getAdPod(id: string): Promise<AdPod> {
    return this.edgeClient.getAdPod(id)
  }

  createAdPod(adPod: AdPodInit): Promise<AdPod> {
    return this.edgeClient.createAdPod(adPod)
  }

  updateAdPod(id: string, adPod: AdPodUpdate): Promise<AdPod> {
    return this.edgeClient.updateAdPod(id, adPod)
  }

  deleteAdPod(id: string): Promise<AdPod> {
    return this.edgeClient.deleteAdPod(id)
  }
}
